import { render } from "./PostDetail.vue?vue&type=template&id=ef80cbde&scoped=true"
import script from "./PostDetail.vue?vue&type=script&lang=js"
export * from "./PostDetail.vue?vue&type=script&lang=js"

import "./PostDetail.vue?vue&type=style&index=0&id=ef80cbde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef80cbde"]])

export default __exports__